<template>
	<div id='profitStatement' >
		<div class='public-content'>
			<div class="profitStatement_top clearfix">
				<el-form :inline='true' class='fl'>
					<el-form-item label='利润表'>
						<el-select v-model="select.reportVal" size="mini" class="report-select" style='width: 80px;'>
							<el-option
								v-for="item in options.reportOps"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template v-if="!isShowQuarter">
							<accounting-period ref="accountingPeriod" @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
						</template>
						<template v-else>
							<el-date-picker
								v-model="date.nowYearPeriods"
								style='width: 140px;'
								type="year"
								size="mini"
								class="year-editor"
								placeholder="选择年"
								:clearable="false"
								:picker-options="pickerBeginDateBefore"
								@change="handleYearChange">
							</el-date-picker>
							<el-select v-model="select.quarterVal" size="mini" class="quarter-select" style='width: 120px;'>
								<el-option
									v-for="item in options.quarterOps"
									:key="item.value"
									:label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</template>
					</el-form-item>
					<el-form-item>
						<el-button size="mini" class='minButton' @click='handlerClickSearch'>
							搜索
						</el-button>
					</el-form-item>
				</el-form>
				<div class="fr">
					<print-operation
						:formData="printForm"
						:showContinuit="false"
					></print-operation>
					<el-button size="mini" @click="handleDownload">
						导出
					</el-button>
				</div>
			</div>
			<public-table :table='tableData'>
				<template slot-scope="props" slot="name">
					<a href="javascript:;" v-text="props.scope.row.name" @click="handlerClick(props.scope.row)"></a>
				</template>
			</public-table>
		</div>
		<balance-sheet-dialog
		    :ruleOfFetch="'实际损益额'"
			:dialogVisible.sync="isShowReport"
			:data="reportDialogData"
			@onRefresh='onRefresh'
			:showRegulation="true">
		</balance-sheet-dialog>
	</div>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import {currencys} from '@/assets/utils/currencyFormat'
	import balanceSheetDialog from '@/components/dialog/balanceSheetDialog'
	import printOperation from '@/components/print'
	export default {
		components: {
			publicTable,
			accountingPeriod,
			balanceSheetDialog,
			printOperation

		},
		data() {
			return {
				isFirstActive: false,
				printForm: {        // 打印参数
					data: {
						quarter: '',
						yearPeriods: '',
					},
					url: '/createPDF/profit',
					continuityUrl: '/createPDF/profit'
				},
				firstGet: true,          // 第一次进页面请求一次
				isShowReport: false,          // 弹框显示
				reportDialogData: {	// 弹窗参数
					reportId: '',
					yearPeriods: '',
					style: ''
				},
				pickerBeginDateBefore: {
					disabledDate: (time) => {
						let res = this.$store.state.accountInfo.yearPeriods;
						let beginStartDateVal = this.date.start||res.startTimeStamp;
						let beginEndDateVal = this.date.end||res.endTimeStamp;
						if (beginEndDateVal && beginEndDateVal) {
							return time.getTime() > beginEndDateVal || time.getTime() < beginStartDateVal
						}
					}
				},
				select: {			// 选择框数据
					reportVal: '1',
					quarterVal: '_1'
				},
				form: {			// 筛选条件
					yearPeriods: '',
					quarter: ''
				},
				date: {			// 日期控件参数
					start: '',
					end: '',
					nowYearPeriods: ''
				},
				options: {			// 选择框option数据
					reportOps: [{
						label: '月报',
						value: '1',
					},{
						label: '季报',
						value: '2',
					}],
					quarterOps: [{
						label: '第一季度',
						value: '_1',
					},{
						label: '第二季度',
						value: '_2',
					},{
						label: '第三季度',
						value: '_3',
					},{
						label: '第四季度',
						value: '_4',
					}],
				},
				value: '',
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '资产',
						value: 'name',
						show: 'template'
					},{
						label: '行次',
						value: 'rowNumber',
						width: 80,
						show: 'normal'
					},{
						label: '累计金额',
						value: 'countYearNumber',
						formatter: this.formatter,
						show: 'normal'
					},{
						label: '本期金额',
						value: 'periodsNumber',
						formatter: this.formatter,
						show: 'normal'
					}],
					operation: {
						label: '操作',
						value: 'operation',
						data: []
					},
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0'
					}
				},
			}
		},
		created() {
			this.$nextTick(() => {
        this.setFaultDate()
      })
		},
		computed: {
			// 是否显示季报
			isShowQuarter () {
				this.form = Object.assign({}, this.form, {
					quarter: this.select.reportVal != '1' ? this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyy') + this.select.quarterVal : '',
					yearPeriods: this.select.reportVal == '1' ? (this.form.yearPeriods ? this.form.yearPeriods : this.$util.formatDate.format(this.date.nowYearPeriods, 'yyyyMM')) : ''
				})
				this.$set(this.printForm, 'data', {
					yearPeriods: this.form.yearPeriods,
					quarter: this.form.quarter
				})

				return this.select.reportVal === '1' ? false : true;
			},
			 getClickCache() {
		        return this.$store.state.loadstatus.isClickCache;
		      }
		},
	    activated() {
	      if(this.getClickCache&&this.isFirstActive) {
          this.setFaultDate()
	        this.handlerClickSearch()
	      }
	      this.isFirstActive = true;
	    },
		methods: {
      // 路由有日期需要赋默认参数
      setFaultDate() {
        const { date } = this.$route.query
        if(date) {
          this.form.yearPeriods = date
          this.printForm.data.yearPeriods = date
          this.$refs.accountingPeriod.setYearPeriodsStart(new Date(date.slice(0,4)+'-'+date.slice(4,6)))
        }
      },
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!row[column.property]) {
					return "";
				}else {
					return currencys(row[column.property]);
				}
			},
			// 导出
			handleDownload (){
				const params = {
					cid: sessionStorage.cid,
					token: sessionStorage.token,
					yearPeriods: this.form.yearPeriods,
					quarter: this.form.quarter
				}

				const router = this.$router.resolve({
					path: '/reportform/exportprofit',
					query: params
				})

				window.open(this.$rootUrl + router.href, '_blank');
			},
			// 显示弹窗
			handlerClick (row) {
				this.reportDialogData = Object.assign({}, this.reportDialogData, {
					reportId: row.id,
					yearPeriods: this.form.yearPeriods,
					style: row.style,
					quarter:this.form.quarter
				})
				this.isShowReport = true;
			},
			// 搜索/获取表格数据
			handlerClickSearch() {
				try {
					this.tableData.loading = true;
					this.$http.post('reportform/profitData' , this.form).then(res=>{
						this.tableData.loading = false;
						if(res) {
							this.tableData.data = res.data.data;
							this.tableData.data.forEach(item=>{
								for (const i in item) {
									if (typeof item[i] === 'number') {
										item[i] = item[i] == 0 ? '' : item[i];
									}
								}
							})
						}
					})
				}catch(e) {
					this.tableData.loading = false;

				}
			},
			// 重载
			onRefresh(data){
				data&&this.handlerClickSearch();
			},
			// 选择期数
			handleYearChange (val) {
				this.$set(this.form, 'quarter', this.$util.formatDate.format(val, 'yyyy')+this.select.quarterVal);
				this.$set(this.printForm.data, 'quarter', this.form.quarter)
			},
			// 接收会计期间数据
			defaultTime(data) {
				this.form = Object.assign(this.form,{
					yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				})
				this.date = Object.assign({}, this.date, {
					start: data.defaultStartDate,
					end: data.defaultEndDate,
					nowYearPeriods: data.yearPeriodsStart
				})
				if(this.firstGet) {
					this.handlerClickSearch();
					this.firstGet = false;
				}
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less' scoped>
	#profitStatement {

	}

</style>



// WEBPACK FOOTER //
// src/pages/reportForm/profitStatement.vue